import { reverse } from "@reactivated";

import { CSRFResponse, FormValidationErrorsResponse, check } from "./types";

/**
 * Name of CSRF Token Header
 */
export const CSRF_HEADER = "X-CSRFToken";

/**
 * Error subclass throw when a fetch request is not successful.
 */
export class FetchError extends Error {
    public readonly response: Response;

    constructor(response: Response, msg: string) {
        super(msg);
        this.response = response;
    }

    public async getFieldError(fieldName: string): Promise<string | null> {
        const data: unknown = await this.response.json();
        let errors: FormValidationErrorsResponse;
        try {
            errors = check(FormValidationErrorsResponse.decode(data));
            /* eslint-disable-next-line unused-imports/no-unused-vars */
        } catch (e) {
            return null;
        }
        const fieldErrors = errors[fieldName] as
            | (typeof errors)[string]
            | undefined;
        if (!fieldErrors) {
            return null;
        }
        return fieldErrors.join("\n");
    }
}

/**
 * Load a CSRF token using the API. Sometimes necessary since CSRF tokens aren't
 * included in cached page responses.
 */
export const loadCSRFToken = async (): Promise<string> => {
    const url = reverse("thelabui:csrftoken-get");
    const response = await fetch(url);
    const data: unknown = await response.json();
    return check(CSRFResponse.decode(data)).csrf_token;
};
